// 配件分类
<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="company">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          分类信息
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="Reload" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="partsCategoryEdit&&company.id!==null&&company.id!==undefined" @click="upDate">保存</el-button>
        </div>
      </div>
      <div class="massing">

        <!-- 左边------- 树型结构 -->
        <div class="detail-wrap left" ref="refLeft">
          <div class="user">
            <basic-container>
              <div class="user__tree">
                <div style="display:flex">
                  <el-input placeholder="关键字过滤" v-model="filterText">
                  </el-input>
                  <el-button class="addBtn" type="primary" size="small" @click="openAddTop"
                             style="margin-left: 10px; line-height: 8px; height: 28px;" v-if="partsCategoryAdd">添加
                  </el-button>
                </div>

                <Tree ref="tree" :maxLevel="MAX_LEVEL" v-if="isRouterAlive" :show-add="partsCategoryAdd"
                      :requestData="requestData"
                      @nodeClick="nodeClick" @addNodeHandle="addNodeHandle"/>

                <el-dialog style="padding: 40px 20px " :close-on-click-modal="false" :visible.sync="addDialogVisible"
                           width="30%" top="5vh" :show-close="true" :before-close="addHandleClose"
                           :title="addDialogTitle == 'edit' ? '编辑名称' : '新增分类'">
                  <el-form :model="addForm" :rules="addRules" label-width="8vw" ref="addRef">
                    <el-form-item label="名称" prop="name">
                      <el-input size="medium" :maxlength="50" v-model="requestParam.categoryName" placeholder="名称"/>
                    </el-form-item>
                    <el-form-item label="编码" prop="code">
                      <el-input size="medium" @blur="inspection(requestParam.categoryCode, null)" :maxlength="10" v-model="requestParam.categoryCode" placeholder="编码"/>
                    </el-form-item>
                    <el-form-item label="类型">
                      <el-select v-model="requestParam.categoryType" :disabled="isChild" style="width: 100%">
                        <!--                        <el-option label="产品" :value="1"/>-->
                        <el-option label="配件" :value="2"/>
                        <el-option label="耗材" :value="3"/>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="完工条码数" prop="barcodeNumber">
                      <el-input size="medium" :maxlength="10" type="number" min="0" v-model="requestParam.barcodeNumber"
                                placeholder="请输入"/>
                    </el-form-item>
                    <el-form-item label="保修期(按月)" prop="guaranteePeriodMonths">
                      <el-input size="medium" :maxlength="10" type="number" min="0"
                                v-model="requestParam.guaranteePeriodMonths"
                                placeholder="请输入"/>
                    </el-form-item>
                    <el-form-item label="保养周期(按月)" prop="serviceIntervalMonths">
                      <el-input size="medium" :maxlength="10" type="number" min="0"
                                v-model="requestParam.serviceIntervalMonths"
                                placeholder="请输入"/>
                    </el-form-item>
                    <el-form-item label="识别标识">
                      <el-input size="medium" :maxlength="10" v-model="requestParam.idMark" placeholder="请输入"/>
                    </el-form-item>
                    <el-form-item label="是否图片质检" prop="picCheckMark">
                      <el-select v-model="requestParam.picCheckMark" style="width: 10vw!important;">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否商城使用" prop="picCheckMark">
                      <el-select v-model="requestParam.saleUse" style="width: 10vw!important;">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="启用" prop="usable">
                      <el-select v-model="requestParam.usable" style="width: 10vw!important;">
                        <el-option label="禁用" :value="0"/>
                        <el-option label="启用" :value="1"/>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="排序" prop="">
                      <el-input-number min="0" max="10" style="width: 10vw!important;" :controls="false" v-model="requestParam.seq"/>
                    </el-form-item>
                    <el-form-item label="矢量图" prop="">
                      <photo-upload :photo-url.sync="requestParam.pic"/>

                    </el-form-item>

                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeAddDialog">取 消</el-button>
                    <el-button size="small" type="primary" @click="addTreeNode">确 定</el-button>
                  </span>
                </el-dialog>
              </div>

            </basic-container>
          </div>
        </div>



        <div class="center"
	ref="refCenter"
	@mousedown.stop.prevent="startResize">⋮</div>
        <!-- 右边------- 基本信息 -->

        <div class="detail-wrap right" ref="refRight" style="    width: calc(100% - 215px);background-color: #fff;">


          <div>

            <!-- 工单信息 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first" style="border-top: 1px solid #ededed;">
                  <b>主信息</b>
                </div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      分类编码：
                    </th>
                    <td>
                      <el-input type="text" style="width:165px" autocomplete="off" v-model="company.categoryCode"
                                clearable @blur="inspection(company.categoryCode, company.id)"/>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      分类名称：
                    </th>
                    <td>
                      <el-input type="text" style="width:165px" autocomplete="off" v-model="company.categoryName"
                                clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      类型：
                    </th>
                    <td v-if="company.categoryType==1">产品</td>
                    <td v-else-if="company.categoryType==2">配件</td>
                    <td v-else-if="company.categoryType==3">耗材</td>
                    <!--                    <td>-->
                    <!-- <el-input type="text" autocomplete="off" style="width:165px" v-model="company.categoryType" :disabled="true" clearable></el-input> -->
                    <!--                      <el-form-item :rules="[{ required: true, trigger: 'blur' }]">-->
                    <!--                        <el-select style="width:165px"  v-model="company.categoryType" >-->
                    <!--                          <el-option label="产品" :value="1" />-->
                    <!--                          <el-option label="配件" :value="2" />-->
                    <!--                          <el-option label="耗材" :value="3" />-->
                    <!--                        </el-select>-->
                    <!--                      </el-form-item>-->
                    <!--                    </td>-->

                  </tr>
                  <div style="height:15px"></div>
                  <tr>
                    <th>
                      上级分类：
                    </th>
                    <td v-if="company.parentName !== null && company.parentName !== undefined">
                      {{ company.parentName }}
                    </td>
                    <td v-else>
                      无
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      完工条码数：
                    </th>
                    <td>
                      <el-input type="number" min="0" autocomplete="off" v-model="company.barcodeNumber" clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      启用：
                    </th>
                    <td>
                      <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                        <el-select style="width:165px" v-model="company.usable">
                          <el-option label="禁用" :value="0"/>
                          <el-option label="启用" :value="1"/>
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>

                  <div style="height:15px"></div>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      保修期(按月)：
                    </th>
                    <td>
                      <el-input type="number" min="0" autocomplete="off" v-model="company.guaranteePeriodMonths"
                                clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      保养周期(按月)：
                    </th>
                    <td>
                      <el-input type="number" min="0" autocomplete="off" v-model="company.serviceIntervalMonths"
                                clearable/>
                    </td>
                    <th>
                      识别标识：
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="company.idMark" clearable/>
                    </td>
                  </tr>
                  <div style="height:15px"></div>

                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      是否图片质检：
                    </th>
                    <td>
                      <el-select style="width:165px" v-model="company.usable">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      是否商城使用：
                    </th>
                    <td>
                      <el-select style="width:165px" v-model="company.saleUse">
                        <el-option label="否" :value="0"/>
                        <el-option label="是" :value="1"/>
                      </el-select>
                    </td>
                    <th>
                      排序：
                    </th>
                    <td>
                      <el-input-number min="0" max="10" style="width:165px" :controls="false" v-model="company.seq"/>
                    </td>

                  </tr>
                  <div style="height:15px"></div>

                  <tr>
                    <th>矢量图：</th>
                    <td>
                      <!-- <photo-upload :photo-url.sync="company.pic"/> -->
        <avue-input-icon v-model="requestParam.icon" :icon-list="iconList"></avue-input-icon>

                    </td>
                  </tr>
                  <div style="height:15px"></div>
                  <tr class="pop_time">
                    <th>
                      创建人：
                    </th>
                    <td>{{ company.createBy }}</td>
                    <th>
                      创建时间：
                    </th>
                    <td>{{ company.createTime }}</td>
                    <!-- <th>修改时间</th>
                <td>{{ company.modifyDate }}</td> -->
                  </tr>
                  <div style="height:15px"></div>
                  </tbody>
                </table>
              </div>
              <!--补充信息< -->
            </div>


          </div>

        </div>


        <!-- 以上右边 -->

      </div>
    </el-form>
  </div>
</template>

<script>
import {
  fetchTree,
  getObj
} from "@/api/admin/type_tree";
import {
  mapGetters
} from "vuex";
import ExcelUpload from "@/components/upload/excel";
import Tree from '@/components/tree/index'
import api from "@/api/projectApi";
import PhotoUpload from "@/components/formItem/photoUpload.vue";
import iconList from '@/const/iconListSvg'

export default {
  // inject: ['reload'],
  name: "type",
  components: {
    PhotoUpload,
    ExcelUpload, Tree
  },
  data() {
    return {
      iconList: iconList,

      partsCategoryEdit: false,
      partsCategoryAdd: false,
      disabledCategoryType: false,
      isRouterAlive: true,
      is_new: false,
      // 以上大小ID  类型信息
      filterText: '',
      addType: 1,
      addNode: '',
      _node_level: '',
      NODE_KEY: "id", // id对应字段
      MAX_LEVEL: 2, // 设定最大层级
      NODE_ID_START: 0, // 新增节点id，逐次递减
      startId: null,
      defaultProps: {
        // 默认设置
        children: "children",
        label: "label",
        id: "id",
        isLeaf: "leaf"
      },
      addDataList: "",
      addForm: {
        name: "",
        code: ""
      },
      addRules: {
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "请输入编码",
          trigger: "blur"
        }],
        barcodeNumber: [{required: true}],
        guaranteePeriodMonths: [{required: true}],
        serviceIntervalMonths: [{required: true}],
        picCheckMark: [{required: true}],
        usable: [{required: true}],
      },
      addDialogTitle: "new",
      addDialogVisible: false,
      // initParam: {},
      // treeData: [],
      // treeID: '',
      company: {
        companyId: "",
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 2,
        barcodeNumber: "",
        guaranteePeriodMonths: 0,
        serviceIntervalMonths: 0,
        idMark: null,
        picCheckMark: 0,
        saleUse: 0,
        pic: null,

        usable: 1,
        seq: 0
      },
      searchForm: {},
      tree: {
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 2,
        usable: 1
      },
      list: [],
      listLoading: true,
      form: {},
      rolesOptions: [],
      postOptions: [],
      excelUpload: false,
      temp: {
        resolve: '',
        leaf: false
      },
      requestParam: {
        companyId: "",
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 2,
        barcodeNumber: 1,
        guaranteePeriodMonths: 0,
        serviceIntervalMonths: 0,
        idMark: null,
        usable: 1,
        picCheckMark: 0,
        saleUse: 0,
        seq: 0,
        pic: null,
      },
      isChild: false,
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.partsCategoryEdit = this.permissions['parts_category_edit']
    this.partsCategoryAdd = this.permissions['parts_category_add']
    // this.partsCategoryEdit = true
  },

  methods: {
            // 左右拖动这里的一个大概说明，就是把减少的div宽度，加到另一个div的宽度上去，就是现实一增一减；变量自己取data定义就行了，
            startResize(event) {
      this.startX = event.clientX;
      this.startWidth = this.$refs.refRight.offsetWidth;
      console.log(event.clientX,this.startWidth,'this.startWidth')
      this.isResizing = true;
 
      window.addEventListener('mousemove', this.doResize);
      window.addEventListener('mouseup', this.stopResize);
    },
    doResize(event) {
      if (this.isResizing) {console.log(event.clientX,'this.startWidth')
        const deltaX = -event.clientX + this.startX;
        this.$refs.refRight.style.width = this.startWidth + deltaX + 'px';
      }
    },
    stopResize() {
      this.isResizing = false;
      window.removeEventListener('mousemove', this.doResize);
      window.removeEventListener('mouseup', this.stopResize);
    },
    inspection(code, id) {
      console.log(code, id, 'check')
      this.$http.post(api.basItemCategory.inspectionUrl, {value: code, id: id}).then(res => {
        if (!res.data.data) {
          this.$message.error("编码已存在，请重新输入")
          if (this.addDialogVisible) {
            this.requestParam.categoryCode = null
          } else
            this.company.categoryCode = null
        }
      })
    },

    requestData(parentId, resolve, leaf) {  // 树形控件数据请求
      this.$http({
        url: api.basItemCategory.getListUrl,
        method: 'post',
        data: {parentId: parentId, excludeCategoryType: 1}
      }).then(res => {
        let array = []
        res.data.data.forEach(item => {
          let obj = {}
          obj.dataId = item.id
          obj.name = item.categoryName
          obj.barcodeNumber = item.barcodeNumber
          obj.guaranteePeriodMonths = item.guaranteePeriodMonths
          obj.serviceIntervalMonths = item.serviceIntervalMonths
          obj.idMark = item.idMark
          obj.categoryType = item.categoryType
          obj.leaf = !item.hasChild
          array.push(obj)
        })
        resolve(array)
      })
    },
    nodeClick(id) {  // 节点点击回显
      this.$http({
        url: api.basItemCategory.getDataUrl,
        method: 'post',
        data: {id: id}
      }).then(res => {
        this.disabledCategoryType = res.data.data.parentId !== null;
        this.requestParam.categoryType = res.data.data.categoryType
        this.company = res.data.data
      })
    },
    addNodeHandle(resolve, leaf, parentId, categoryType) {
      this.isChild = true
      this.addDialogVisible = true
      this.requestParam.parentId = parentId
      this.requestParam.categoryType = categoryType
      this.temp.resolve = resolve
      this.temp.leaf = leaf
    },

    addTreeNode() {
      // this.requestParam.categoryType = 1
      this.$http({
        url: api.basItemCategory.addDataUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        if (this.requestParam.parentId === '') {
          this.$refs.tree.treeData.push({
            dataId: res.data.data,
            name: this.requestParam.categoryName,
            categoryType: this.requestParam.categoryType,
            // barcodeNumber: this.requestParam.barcodeNumber,
            leaf: false
          })
        } else {
          this.temp.resolve({
            dataId: res.data.data,
            name: this.requestParam.categoryName,
            // barcodeNumber: this.requestParam.barcodeNumber,
            leaf: this.temp.leaf
          })
        }
        // this.requestParam.categoryType = 1
        this.closeAddDialog()
        this.$message.success("保存成功！");
      })
    },

    closeAddDialog() {
      this.addDialogVisible = false
      this.requestParam.categoryCode = ''
      this.requestParam.categoryName = ''
      this.requestParam.categoryType = '2'
      this.requestParam.barcodeNumber = '1'
      this.requestParam.guaranteePeriodMonths = '0'
      this.requestParam.serviceIntervalMonths = '0'
      this.requestParam.idMark = ''
      this.requestParam.picCheckMark = 0
      this.requestParam.usable = 1
      this.requestParam.seq = 0
      this.requestParam.pic = null
    },
    addHandleClose() {
      this.addDialogVisible = false;
      this.$refs.addRef.resetFields();
      this.isChild = false
    },


    // 新增顶级结点
    openAddTop() {
      //  this.addType = 1;
      // this.addForm.name = "";
      // this.addForm.code = "",
      this.addDialogVisible = true;
      this.addDialogTitle = "new";
      this.requestParam.parentId = ''
      this.requestParam.categoryType = 2
      this.isChild = false
    },


    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    upDate() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            let formData = this.company;
            console.log(formData, 'formData的值')
            this.$http({
              url: api.basItemCategory.updateDataUrl,
              method: `post`,
              data: formData,
            }).then(() => {
              this.$message.success("保存成功！");
              this.reload()
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！");
            })
          });
        }
      });

    },

    saveData(_data, obj, _node) {
      let formData = this.company;

      console.log(formData, 'formData的值')
      this.$http({
        url: api.basItemCategory.addDataUrl,
        method: `post`,
        data: formData,
        isLoading: true,
      }).then(res => {
        obj.id = res.data.data
        // 判断字段是否存在
        if (!_data.children) {
          this.$set(_data, "children", []);
        }
        // 新增数据
        _data.children.push(obj);
        // 展开节点
        if (!_node.expanded) {
          _node.expanded = true;
        }
      });
      // this.reload()
    },

    init(_node, _data, _name) {
      // fetchTree(this.tree).then(response => {
      //   let treeData = response.data.data;
      //   console.log(response.data.data, "response.data.data值");
      // this.treeData = treeData.map(item => ({
      //   label: item.categoryName,
      //   id: item.id,
      //   leaf:Number(item.isChild)==1?false:true,
      //   categoryCode: item.categoryCode
      // }))
      //   console.log(this.treeData, "this.treeData值");


      // });
    },
    loadChildNode(node, resolve) {
      console.log(node, "loadChildNode.node")
      const spaceParentGuid = {
        parentId: node.data.id
      }
      fetchTree(spaceParentGuid).then(({
                                         data
                                       }) => {
        console.log(data, "data.data的值"),
          resolve(
            data.data.map(item => {
              return {
                label: item.categoryName,
                id: item.id,

                leaf: Number(item.isChild) == 1 ? false : true,
              }
            })
          )
      });
      // this.treeData=data.data


    },
    // 重置
    Reload() {
      this.company = []
    },
    handleNodeClick(data) {
      let id = {id: data.id};
      // this.treeID = data.id;
      console.log(id, "点击id的值");
      // this.company.id = Number(id);
      getObj(id).then(response => {
        this.company = response.data.data;
        console.log(response.data.data, "response.data.data值");
        console.log(this.company, "this.treeData值");
      }).catch(err => {

      })
    },
    exportExcel() {
      this.downBlobFile("/admin/user/export", this.searchForm, "user.xlsx");
    },

  },
  watch: {
    filterText(val) {
      console.log(val)
      this.$refs.tree.filterRef(val);
    }
  },
};

</script>

<style lang="scss" scoped>
.user__tree{
  max-height: 80vh;
    overflow: hidden;
    overflow-y: scroll;
}
.is_new {
  display: none
}

.d-item {
  border-left: 1px solid #ededed;
}

.el-main {
  display: inline-block;
  height: 791.18px;
}

::v-deep .el-card__body,
.el-main {
  padding: 20px 8px;
}

.basic-container {
  padding: 0px 0px 8px 0px !important;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;

  tr th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);


  }
}

.pop_time {
  td {
    font-weight: 400;
    text-align: left;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.massing {
  display: flex;
  height: calc(100vh - 94px);
  .left {
      flex: 1;
      height: 100%;
      min-width: 250px;
      width:600px
    }
    .center {
      cursor: col-resize;//拖动鼠标样式
      height: 100%;
      width: 8px;

      cursor: col-resize;
  // position: relative;
  // top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: 150px;
  margin-right: 5px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  font-size: 32px;
  color: white;
    }
    .right {
      width: calc(100% - 600px);
      min-width: calc(100% - 600px);
      height: 100%;
    }

}

.detail-wrap .d-header {
  border-bottom: solid 1px #E9E9E9;
  height: 34px;
  line-height: 34px;
  margin: 7px 0px 6px 12px;
  padding: 0px 24px 0 14px;
  font-size: 13px;
  overflow: hidden;
  background-color: #FFF;
}

.detail-wrap .d-header .fl > i {
  color: #00c4b3;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}

.d-cont {
  border-bottom: 1px solid #ededed;
  padding-top: 10px;

}

::v-deep[data-v-43ab9747] .el-card__body, .el-main[data-v-43ab9747] {
  padding: 6px 8px;
  border: 1px solid #ededed;
  margin-top: 10px;
  margin-left: 12px;
  margin-right: 5px;
}

.user {
  // height: 802.18px;
  background-color: #fff;
  margin-left: 12px;

  &__tree {
    // padding: 15px;
    // border: 1px solid #ededed;
    // width: 192px;
    // height: 755px;
  }

  &__main {
    .el-card__body {
      padding-top: 0;
    }
  }
}


.basic-container .el-card {
  width: 100%;
  height: 800px;
}


.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep.el-tree {
  width: calc(100% - 32px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: rgba(86, 86, 86, 0.96);
}


// 重新修改tree组件样式
.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;
    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}
tr td {
  font-weight: 400;
  text-align: left;
  width: 112px;
  font-size: 12px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
}
</style>
